<script>
import {getSettingItem, setSystemSettingInfo} from "@/api/setting-api";
import {getAllArea} from "@/api/device-manager-api";

export default {
  name: "LauncherFormSettingView",
  data() {
    return {
      target: "LANGUAGE_EN",
      type: "AREA_FIELD",

      areaTree: [],

      areaTableData: [],

      areaSettingContent: {
        title: {},
        addr: {}
      },
    }
  },
  mounted() {
    getAllArea().then(({data}) => {
      console.log("getAllArea", data)
      if (data.code === 200) {
        this.areaTree = data.data
        this.areaTree.forEach((item) => {
          this.$set(item, "hasChildren", (item.areas || []).length > 0)
          this.areaTableData.push({
            id: item.id,
            type: "title",
            show: item.name,
          })
          ;(item.areas || []).forEach((child) => {
            this.areaTableData.push({
              id: child.id,
              type: "title",
              show: child.name,
            })
            this.areaTableData.push({
              id: child.id,
              type: "addr",
              show: child.address,
            })
          })
        })
      }
      console.log("areaTree @@@@@@@@@@", this.areaTree)
      this.setupPage()
    }).catch((err) => {
      console.log("getAllArea err", err)
    })
  },

  methods: {
    setupPage() {
      getSettingItem(this.target, this.type).then(({data}) => {
        console.log("getSettingItem", data)
        if (data.code === 200 && data.data.length > 0) {
          let setting = data.data[0]
          this.areaSettingContent = JSON.parse(setting.content)
        }
      }).catch((err) => {
        console.log("getSettingItem err", err)
      })
    },


    saveAreaSetting() {
      let content = JSON.stringify(this.areaSettingContent)
      let setting = {
        target: this.target,
        type: this.type,
        content: content,
        state: "VALID"
      }
      setSystemSettingInfo(setting).then(({data}) => {
        console.log("setSystemSettingInfo", data)
        if (data.code === 200) {
          this.$message.success("保存成功")
        } else {
          this.$message.error("保存失败")
        }
      }).catch((err) => {
        console.log("setSystemSettingInfo err", err)
      })
    },


  }, // methods
}
</script>

<template>
  <div>
    <el-table :data="areaTree" stripe border row-key="id">
      <el-table-column type="expand">
        <template slot-scope="scope">
          <el-table :data="scope.row.areas" stripe border size="small" class="ml-12">
            <el-table-column prop="name" label="子区域名称" width="200">
              <template slot-scope="subScope">
                {{ subScope.row.name }}
              </template>
            </el-table-column>
            <el-table-column label="子区域英文名称">
              <template slot-scope="subScope">
                <el-input v-model="areaSettingContent.title[subScope.row.id]"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="子区域地址" width="200"></el-table-column>
            <el-table-column label="子区域英文地址">
              <template slot-scope="subScope">
                <el-input v-model="areaSettingContent.addr[subScope.row.id]"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="区域名称" width="200"></el-table-column>
      <el-table-column prop="address" label="英文名称">
        <template slot-scope="scope">
          <el-input v-model="areaSettingContent.title[scope.row.id]"></el-input>
        </template>
      </el-table-column>
    </el-table>

    <div class="p-4 text-center" style="width: 80%">
      <el-button class="w-40" type="primary" @click="saveAreaSetting">保存</el-button>
    </div>


  </div>
</template>

<style scoped lang="less">

</style>
